import React from 'react';
// import StringField from 'react-jsonschema-form/lib/components/fields/StringField';
// import omit from 'lodash.omit';
import uniq from 'lodash.uniq';
import isDate from 'lodash.isdate';
import isBoolean from 'lodash.isboolean';
import isString from 'lodash.isstring';
import isNumber from 'lodash.isnumber';
import cloneDeep from 'lodash.clonedeep';
import DateTimeWidget from '../components/DateTimeWidget';
import { FORMAT_DATE_TIME, FORMAT_DATE } from './date';
import PhoneNumberWidget from '../components/PhoneNumberWidget';


export const FIELD_TYPE_MAPPING = {
  string: {
    schema: {
      type: 'string'
    },
    uiSchema: {}
  },
  phone_number: {
    schema: {
      type: 'string'
    },
    uiSchema: {
      'ui:widget': PhoneNumberWidget
    }
  },
  date: {
    schema: {
      type: 'string',
      format: 'date',
      dateFormat: FORMAT_DATE
    },
    uiSchema: {
      'ui:widget': DateTimeWidget
    }
  },
  datetime: {
    schema: {
      type: 'string',
      format: 'date-time',
      dateFormat: FORMAT_DATE_TIME
    },
    uiSchema: {
      'ui:widget': DateTimeWidget
    }
  },
  number: {
    schema: {
      type: 'integer'
    },
    uiSchema: {
      'ui:widget': 'updown'
    }
  },
  boolean: {
    schema: {
      type: 'boolean'
    }
  },
  select: {
    schema: {
      type: 'string'
    },
    uiSchema: {
      // 'ui:widget': 'checkboxes'
    }
  },
  select_with_values: {
    schema: {
      type: 'string'
    },
    uiSchema: {
      // 'ui:widget': 'checkboxes'
    }
  },
  checkbox: {
    schema: {
      type: 'array',
      items: {
        type: 'string'
      },
      uniqueItems: true
    },
    uiSchema: {
      'ui:widget': 'checkboxes'
    }
  },
  default: {
    schema: {
      type: 'string'
    },
    uiSchema: {}
  }
};

let index = 0;
const fixFieldId = header => {
  if (header.length === 0) {
    index = index + 1;
    return 'N/A' + index;
  }
  return header;
};

const sanitizeField = field => {
  const identifier = fixFieldId(field.identifier);
  return {
    ...field,
    identifier: identifier,
    title: field.title || identifier
  };
};

export const sanitizeFields = fields => fields.map(sanitizeField);

export const getFieldForHeader = (header, type, typeAutodetected) => {
  const id = fixFieldId(header);
  return {
    csvHeader: id,
    identifier: id,
    visible: true,
    required: false,
    dataType: type,
    dataTypeAutodetected: typeAutodetected || type,
    //TODO
    // validator: VALIDATOR_KEY_NUMBER,
    title: id,
    description: ''
  };
};

export const getFieldSchemaFromField = field => {
  const { dataType, values, defaultValue } = field;
  const { schema: schemaSource, uiSchema: uiSchemaSource } =
    cloneDeep(FIELD_TYPE_MAPPING[dataType] || FIELD_TYPE_MAPPING.default);
  const schema = {
    at: field.at,
    title: field.title,
    description: field.description,
    validator: field.validator,
    ...schemaSource
  };
  let uiSchema = {
    ...uiSchemaSource,
    ...(field.readonly
      ? {
          'ui:readonly': true
        }
      : {})
  };
  //special fields
  switch (dataType) {
    case 'date':
      if (field.dateFormat) {
        schema.dateFormat = field.dateFormat;
      }
      break;
    case 'select_with_values':
      schema.enum = (values || []).map(value => value.value);
      schema.enumNames = (values || []).map(value => value.label);
      break;
    case 'select':
      schema.enum = values;
      break;
    case 'checkbox':
      schema.default = defaultValue || [];
      schema.items.enum = values;
      break;
    default:
      break;
  }
  return {
    schema,
    uiSchema
  };
};

const BOOLEAN_TYPE_MATCHER = /^(y|n|yes|no|true|false)$/i;
const couldBeBoolean = string => BOOLEAN_TYPE_MATCHER.test(string);

const DATE_TYPE_MATCHER = /^([0-9]{1,4}[-./][0-9]{1,4}[-./][0-9]{1,4})$/i;
const couldBeDate = string => DATE_TYPE_MATCHER.test(string);

const DATE_TIME_TYPE_MATCHER = /^([0-9]{1,4}[-./][0-9]{1,4}[-./][0-9]{1,4})[\sT]+[0-9]{2}:[0-9]{2}(:[0-9]{2}([.+0-9Z]+)?)?$/i;
const couldBeDateTime = string => DATE_TIME_TYPE_MATCHER.test(string);

const MAX_UNIQUES_FOR_SELECT = 3;
const MIN_VALUES_FOR_UNIQUES = 15;
const couldBeSelect = values => {
  const uniques = uniq(values);
  if (
    values.length > MIN_VALUES_FOR_UNIQUES &&
    uniques.length < MAX_UNIQUES_FOR_SELECT
  ) {
    return uniques;
  }

  return false;
};

export const getTypeOf = (value, label) => {
  if (isNumber(value)) {
    return 'string';
  }
  if (isBoolean(value)) {
    return 'boolean';
  }
  if (isDate(value)) {
    return 'date';
  }
  if (isString(value)) {
    if (couldBeDateTime(value)) {
      return 'datetime';
    }
    if (couldBeDate(value)) {
      return 'date';
    }
  }
  return 'string';
};

export const guessFieldTypes = data => {
  const fieldsData = {};

  if (data.length > 2) {
    for (let i = 1; i < data.length; i++) {
      const row = data[i];
      Object.keys(row).forEach(key => {
        const type = getTypeOf(row[key], key);
        if (!fieldsData[key]) {
          fieldsData[key] = {
            dataType: type,
            optionTypes: {},
            values: []
          };
        } else {
          if (type !== fieldsData[key].dataType) {
            fieldsData[key].optionTypes[type] =
              (fieldsData[key].optionTypes[type]
                ? fieldsData[key].optionTypes[type]
                : 0) + 1;
          }
        }
        fieldsData[key].values.push(row[key]);
      });
    }
  }
  return fieldsData;
};



// WEBPACK FOOTER //
// ./src/helpers/fields.js